import { render, staticRenderFns } from "./MerchantPopups.vue?vue&type=template&id=d447d58a&scoped=true"
import script from "./MerchantPopups.vue?vue&type=script&lang=js"
export * from "./MerchantPopups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d447d58a",
  null
  
)

export default component.exports